/*

	Note that the mobile nav is just a modal.
	@see modal.js

*/
export default {

	init() {
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		const header = document.querySelector('.site-header');
		const hero = document.querySelector('.page-hero, .page-header');

		Nav.header = document.querySelector('.site-header');
		Nav.hero = document.querySelector('.page-hero, .page-header');

		Nav.navFixedState()
		window.addEventListener('scroll', Nav.navFixedState);
	},

	navFixedState() {
		let threshold = Nav.hero.offsetHeight;

		if (window.scrollY > threshold) {
			Nav.header.classList.add('is-fixed');
		} else {
			Nav.header.classList.remove('is-fixed');
		}
	},

};
